import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  PyramidCategory,
  PyramidLegendItem
} from 'src/app/components/categories-pyramid-display/categories-pyramid-display.component';
import {ScoreDevelopmentChipVm, ScoreDevelopmentVm} from '../../models/team-dynamic.vm';

@Component({
  selector: 'app-team-pyramid-flip',
  templateUrl: './team-pyramid-flip.component.html',
  styleUrls: ['./team-pyramid-flip.component.scss']
})
export class TeamPyramidFlipComponent {
  @Input() categories: PyramidCategory[] = [];
  @Input() legend: PyramidLegendItem[] = [];
  @Input() teamScores: ScoreDevelopmentVm = {labels: [], values: []};
  @Input() workspaceScores: ScoreDevelopmentVm = {labels: [], values: []};
  @Input() scoreChips: ScoreDevelopmentChipVm[] = [];
  @Input() activeChipUuid: string | null = null;
  @Input() loadingScores: boolean = false;

  @Output() categorySelected = new EventEmitter<PyramidCategory>();
  @Output() chipSelected = new EventEmitter<string | null>();

  view: 'all' | 'development' = 'all';
  hasFlipped: boolean = false;

  setView(view: 'all' | 'development') {
    if (this.view === view) {
      return;
    }
    this.view = view;
    if (view === 'development') {
      this.hasFlipped = true;
    }
  }

  onCategorySelected(category: PyramidCategory) {
    this.categorySelected.emit(category);
  }

  onChipSelected(uuid: string | null) {
    this.chipSelected.emit(uuid);
  }
}
